import { SET_THEMES } from '../actions';
import { reduxStoreTypes } from '@type/redux-store';

const theme = (theme: string = 'standard', action: reduxStoreTypes.ThemeAction) => {
    if (action.type === SET_THEMES) {
        return action.theme
    }
    return theme
}
export default theme